export const SET_TASKS_DOWNLOAD_RECORD = 'Tasks/DownloadRecord/set';
